import { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import PropTypes from "prop-types";
import ResponsiveButton from "../../components/ResponsiveButton/ResponsiveButton";

// Images
import HeroImg from "../../assets/spiderlegs.png";

const Hero = ({ theme = "default-theme" }) => {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <div className={`pb-20 pt-28 ${theme}`}>
      <div className="px-4 flex">
        <div className="grid grid-cols-1 xsm:grid-cols-1 sm:grid-cols-1 md:grid-cols-1 mdd:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 place-items-center 2xl:px-72">
        
          {/* KUVA */}
          <div data-aos="fade-left" data-aos-easing="linear"
            data-aos-duration="1000" className="xxxsm:order-1 xxsm:order-1 xsm:order-1 sm:order-1 md:order-1 mdd:order-2 lg:order-2 xl:order-2 2xl:order-2 z-0">

            <img src={HeroImg} title="Spiderlegs productions hero image" alt="Spiderlegs productions hero" className="xxxsm:scale-150 xxsm:scale-150 xsm:scale-150 s24:scale-150 sm:scale-150 md:scale-150 mdd:scale-150 lg:scale-150 xl:scale-150 2xl:scale-150 relative pt-20 drop-shadow-[10px_10px_8px_rgba(0,0,0,0.80)]"/>
          </div>

          {/* TEKSTIOSIO */}
          <div data-aos="fade-right" className="dark:bg-violet bg-primary dark:bg-opacity-75 bg-opacity-75 p-5 order-1 rounded-3xl z-10" style={{ maxWidth: "100%" }}>
            
            {/* ISKULAUSE */}
            <div data-aos="fade-right" className="flex flex-row items-center">
              <p className="text-darkest dark:text-primary text-left text-1xl font-customFont1 font-bold dark:text-shadow-xxl">
                TÄYDEN PALVELUN RATKAISUT
              </p>
            </div>

            {/* OTSIKKO */}
            <h1 className="font-customFont2 dark:text-shadow-lg text-left text-darkest dark:text-primary text-5xl sm:text-4xl md:text-5xl lg:text-5xl xl:text-6xl 2xl:text-6xl font-bold leading-[1.2]">
              Tapahtumasi tarpeet yhdestä paikasta!
            </h1>

            {/* TEKSTI */}
            <p data-aos="fade-right" className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light">

              Unohda tapahtuman järjestämisen stressi! Meiltä saat kaiken, mitä tarvitset 
              onnistuneisiin bileisiin: <span className="font-bold">Ammattitaitoiset esiintyjät ja ammattitason äänentoiston sekä näyttävän valaistuksen.</span>
              <br /><br />

              Olipa kyseessä <span className="font-bold">häät, yritystilaisuus, kesäjuhlat tai mökkibileet</span>, me huolehdimme siitä, että tapahtumasi kuulostaa ja näyttää täydelliseltä. <br /><br />
              
              Valitse laitteet helposti valikoimastamme, vuokraa, nouda ja palauta joustavasti – tai anna meidän hoitaa koko tapahtumatekniikka kuljetuksineen alusta loppuun. Sinä voit keskittyä juhlimiseen, me sensijaan varmistamme, että kaikki toimii täydellisesti.
              <br /><br />

              {/* Kokeile uutta <span className="font-bold">ohjattua tapahtumatekniikan kartoituspalveluamme tai buukkaa esiintyjä tilaisuuteesi muutamalla klikkauksella!</span> */}

            </p>

            <div className="hero-button flex flex-col items-center gap-6" data-aos="fade-up">
              {/* Vuokrattavat laitteet */}
              <Link
                to="/vuokrattavat"
                onClick={() => window.scrollTo({ top: 0, left: 0, behavior: "auto" })}
                className="w-full max-w-xs sm:max-w-md"
              >
                <ResponsiveButton variant="hero" className="w-full">
                  Vuokrattavat laitteet
                </ResponsiveButton>
              </Link>

              {/* Löydä esiintyjä */}
              <Link
                to="/esiintyjat"
                state={{ skipModal: false }} // ✅ tämä laukaisee modalin
                onClick={() => window.scrollTo({ top: 0, left: 0, behavior: "auto" })}
                className="w-full max-w-xs sm:max-w-md"
              >
                <ResponsiveButton variant="hero" className="w-full">
                  Löydä esiintyjä
                </ResponsiveButton>
              </Link>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Hero.propTypes = {
  theme: PropTypes.string,
};

export default Hero;
